import ServiceDetailPage from "@/components/ServiceDetailPage";

const IpIncubation = () => <ServiceDetailPage pageKey="ipIncubation" />;

export default IpIncubation;
